import { render } from "./SocialIcons.vue?vue&type=template&id=7a15ad12&scoped=true"
import script from "./SocialIcons.vue?vue&type=script&lang=js"
export * from "./SocialIcons.vue?vue&type=script&lang=js"

import "./SocialIcons.vue?vue&type=style&index=0&id=7a15ad12&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a15ad12"]])

export default __exports__